import React from 'react';
import CloseButton from "../PageControls/CloseButton";

// Declined = the customer said no; Dismissed = staff closed the alert. With showDeclineButton off
// there is a single Close that records Dismissed.
export default function AlertResponseButtons({showDeclineButton = true, onDeclined, onDismissed}) {
    if (!showDeclineButton) {
        return <CloseButton onClose={onDismissed} label={'Close'}/>
    }

    return (
        <>
            <CloseButton onClose={onDeclined} label={'Declined'}/>
            <CloseButton onClose={onDismissed} label={'Dismissed'}/>
        </>
    )
}
